<template>
    <v-col cols="12" class="pa-4" ref="item">
        <template v-if="message.type == 'noti'">
            <item-noti v-bind="{ message }" />
        </template>
        <template v-if="message.type == 'peer'">
            <item-peer v-bind="{ message, index }" />
        </template>
        <template v-if="message.type == 'user'">
            <item-user v-bind="{ message, index }" />
        </template>
    </v-col>
</template>

<script>
import { initLectureChatMessage } from "@/store/lecture/chat/chat.inits";
import ItemNoti from "./item/item-noti.vue";
import ItemPeer from "./item/item-peer.vue";
import ItemUser from "./item/item-user.vue";

export default {
    components: {
        ItemNoti,
        ItemPeer,
        ItemUser,
    },
    props: {
        index: { type: Number, default: 0 },
        message: { type: Object, default: initLectureChatMessage },
        isScrollFixed: { type: Boolean, default: false },
    },
    mounted() {
        if (this.isScrollFixed) {
            this.$nextTick(() => {
                const intervalId = setInterval(() => {
                    const el = this.$refs["item"];
                    if (!el) return;
                    this.$emit("scroll");
                    clearInterval(intervalId);
                }, 10);
            });
        }
    },
};
</script>

<style></style>
